import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { API_ORIGIN } from '../../lib/api';

interface Snapshot {
  kind: string;
  payload: Record<string, unknown>;
  createdAt: string;
}

export function SharedSnapshotPage() {
  const { t, i18n } = useTranslation();
  const { slug } = useParams<{ slug: string }>();
  const [snap, setSnap] = useState<Snapshot | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    axios.get<Snapshot>(`${API_ORIGIN}/share/${slug}`)
      .then((r) => setSnap(r.data))
      .catch((e) => setErr(e?.response?.status === 404 ? t('common.notFound') : t('common.failed')));
  }, [slug, t]);

  if (err) {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink-500">
        {err}
      </div>
    );
  }
  if (!snap) return null;

  return (
    <div className="min-h-screen bg-white dark:bg-ink-950 p-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-sm text-ink-500 mb-2">{t('brand')} · {t('snapshot.sharedSnapshot')}</div>
        <h1 className="display text-3xl font-semibold mb-1">{snap.kind}</h1>
        <p className="text-xs text-ink-500 num mb-6">
          {t('snapshot.frozenAt')} {new Date(snap.createdAt).toLocaleString(i18n.language)}
        </p>
        <Card className="p-6">
          <pre className="text-xs text-ink-700 dark:text-ink-200 whitespace-pre-wrap break-words font-mono">
            {JSON.stringify(snap.payload, null, 2)}
          </pre>
        </Card>
      </div>
    </div>
  );
}
